(() => {
  if (customElements.get('ss-country-welcome')) return;
  class CountryWelcome extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.hidden = true;
      this.ready = false;
      this.panel = this.querySelector('.ss-country-welcome__panel');
      this.templates = [...this.querySelectorAll('template')];
      if (!this.panel || !this.templates.length || Shopify.designMode) return;
      this.timer = setTimeout(() => this.prepare(), Number(this.dataset.delay) || 4000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      clearTimeout(this.timeout);
      this.controller?.abort();
      this.observer?.disconnect();
    }
    dismissed(country) {
      try { return sessionStorage.getItem('ss-country-welcome-dismissed') === country; }
      catch { return false; }
    }
    remember() {
      try { sessionStorage.setItem('ss-country-welcome-dismissed', this.country); }
      catch {}
    }
    async prepare() {
      const available = this.dataset.available.split(',');
      const selected = this.dataset.country;
      const supported = [...new Set(this.templates.map(t => t.dataset.country))];
      if (['AT', 'CH'].includes(selected)) return;
      let country = supported.includes(selected) ? selected : null;
      if (!country) {
        const requestController = new AbortController();
        this.controller.signal.addEventListener('abort', () => requestController.abort(), {once:true});
        this.timeout = setTimeout(() => requestController.abort(), 4000);
        try {
          const root = this.dataset.root.replace(/\/$/, '') + '/';
          const response = await fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true', {signal:requestController.signal});
          if (!response.ok) return;
          const data = await response.json();
          country = data.detected_values?.country?.handle;
          if (!country) {
            const suggestion = data.suggestions?.find(s => s.parts?.country?.confidence >= 0.9);
            country = suggestion?.parts?.country?.handle;
          }
        } catch { return; }
        finally { clearTimeout(this.timeout); }
      }
      if (!this.isConnected || !supported.includes(country) || !available.includes(country) || this.dismissed(country)) return;
      const currentLanguage = this.dataset.language.toLowerCase().split('-')[0];
      if (country === selected && ((country === 'NL' && currentLanguage === 'nl') || (country === 'FR' && currentLanguage === 'fr') || (country === 'BE' && ['nl', 'fr'].includes(currentLanguage)))) return;
      this.country = country;
      const variants = this.templates.filter(t => t.dataset.country === country);
      const preferences = [this.dataset.language, ...(navigator.languages || [navigator.language])].map(l => l.toLowerCase().split('-')[0]);
      let template;
      if (country === 'BE') {
        const preferred = preferences.find(l => ['nl', 'fr'].includes(l));
        template = variants.find(t => t.dataset.language === (preferred || 'en'));
      } else template = variants[0];
      if (!template) return;
      this.panel.replaceChildren(template.content.cloneNode(true));
      this.panel.lang = template.dataset.targetLanguage && template.dataset.targetLanguage !== 'en' ? template.dataset.targetLanguage : template.dataset.language;
      this.panel.setAttribute('aria-labelledby', template.dataset.titleId);
      const form = this.panel.querySelector('form');
      const targetLanguage = template.dataset.targetLanguage || 'en';
      if ((country === selected && currentLanguage === targetLanguage) || !(template.dataset.languages || '').split(',').includes(targetLanguage)) form.hidden = true;
      this.panel.querySelector('.ss-country-welcome__close').addEventListener('click', () => {
        this.remember();this.ready=false;this.hidden=true;this.observer?.disconnect();
      }, {signal:this.controller.signal});
      form.addEventListener('submit', () => this.remember(), {signal:this.controller.signal});
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') this.panel.querySelector('.ss-country-welcome__close').click();
      }, {signal:this.controller.signal});
      this.ready = true;
      this.updatePosition();
      this.observer = new MutationObserver(records => {
        if (records.every(r => this.contains(r.target))) return;
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {this.frame=null;this.updatePosition();});
      });
      this.observer.observe(document.body, {childList:true,subtree:true,attributes:true,attributeFilter:['open','hidden','class','style','aria-hidden']});
      window.addEventListener('resize', () => this.updatePosition(), {signal:this.controller.signal});
    }
    updatePosition() {
      if (!this.ready) return;
      const cookieSelectors = '#shopify-pc__banner, .shopify-pc__banner__dialog, #tiny-cookie, #tinycookie, .tiny-cookie, .tinycookie';
      const visible = e => { const r=e.getBoundingClientRect();const s=getComputedStyle(e);return r.width>0&&r.height>0&&s.display!=='none'&&s.visibility!=='hidden'&&Number(s.opacity)>0; };
      const cookie = [...document.querySelectorAll(cookieSelectors)].some(visible);
      const drawer = [...document.querySelectorAll('cart-drawer[open], search-drawer[open], menu-drawer[open], dialog[open]')].some(visible);
      this.hidden = cookie || drawer;
      let bottom = innerWidth < 700 ? 16 : 20;
      for (const e of document.querySelectorAll('product-sticky-bar, .product-sticky-bar, #PBarNextFrame')) {
        if (!visible(e)) continue;
        const r = e.getBoundingClientRect();
        if (r.bottom >= innerHeight - 2 && r.height < innerHeight / 3) bottom = Math.max(bottom, innerHeight - r.top + 12);
      }
      const value=bottom+'px';
      if (this.style.getPropertyValue('--ss-welcome-bottom') !== value) this.style.setProperty('--ss-welcome-bottom',value);
    }
  }
  customElements.define('ss-country-welcome', CountryWelcome);
})();
